import isArray from 'lodash/isArray';
import isUndefined from 'lodash/isUndefined';

import type { FetchBaseQueryArgs } from '@reduxjs/toolkit/dist/query/fetchBaseQuery';

export const paramsSerializer: FetchBaseQueryArgs['paramsSerializer'] =
  params => {
    const initUrlSearchParams = new URLSearchParams();

    return Object.entries(params)
      .reduce((acc: URLSearchParams, [key, value]) => {
        if (isArray(value)) {
          value.forEach(arrayItem => acc.append(key, arrayItem));
        }

        if (!isArray(value) && !isUndefined(value)) {
          acc.append(key, value);
        }

        return acc;
      }, initUrlSearchParams)
      .toString();
  };
